import { IQuotationDetails, IQuotationTitle } from "../../../main/second/mainbar/orderQuotation/types/quotation";
import { statusConverter } from "../../../generic/artcoded/statusAzmanot";
import { requests } from "../config";
import { ISellerTableProductItem } from "../Seller/models/tableData";
import { IProductCustomerItem, OrderDetail } from "./models/detailsProductCustomer";
import { IOrderPostData } from "./models/orderPostData";
import { IOrderModifyData, IOrderPutData, IPatchOrderData } from "./models/orderPutData";
import { IOrderQuotationDetailsResponse, IOrderQuotationPostData, IQuotationProductListResponse } from "./models/orderQuotations";
import { IOrderTitleItemShort, IOrderWithDetailsItemGO } from "./models/orders";
import { OrderStatusHistoryResponse } from "./models/orderStatusLog";
import { IUpdateSizeInOrdersData } from "./models/reqestData";

export const Orders = {
    getOrdersShort: (dateFrom: string, dateTo: string): Promise<IOrderTitleItemShort[]> => requests.get(`order/orders_short?DateFrom=${dateFrom}&DateTo=${dateTo}`, 'go'),
    getOrders: (date1: string, date2: string) => requests.get(`order?fromDate=${date1}&toDate=${date2}`, 'node'),
    getOrder: (id: number) => requests.get(`order/${id}`, 'node'),
    createOrder: (data: IOrderPostData) => requests.post(`order`, 'node', data),
    createOrderGo: (data: IOrderPostData) => requests.post(`order`, 'go', data),
    editOrder: (id: number, data: IOrderPutData) => requests.put(`order/${id}`, 'node', data),
    changeOrderStatusGo: (orderID: number, status: number) => requests.put(`order/${orderID}`, 'go', {Status: status}),
    deleteOrder: (id: number) => requests.delete(`order/${id}`, 'node'),
    getGoodPrice: (
        date: string, 
        // growerID: number, 
        customerID: number,
        productID: number,
        varietyID: number,
        sizeID: string,
        packID: number
    ) => requests.get(`price?Date=${date}&GrowerID=0&CustomerID=${customerID}&ProductID=${productID}&VarietyID=${varietyID}&Size=${sizeID}&PackID=${packID}&QualityID=0`, 'go'),
    modifyOrder: (
        orderType: number, orderID: number, data: IOrderModifyData
        ) => requests.put(`order/${orderType}/${orderID}/`, 'go', data),
    passNewOrderToWS: (
         data: any
        ) => requests.post(`order/ws`, 'go', data),
    patchOrderDataRemarks: (data: IPatchOrderData) => requests.patch(`delivery/15?`, 'node', data),
    getExistOrdersForClients: (date: string) => requests.get(`customer/with_orders_count?Date=${date}`, 'go'),
    changeOrderStatus: (orderID: number, status: number) => requests.put(`order/${orderID}`, 'node', {Status: status}),
    getOrdersWithDetails: (date: string, statuses: string) => requests.get(`order/orders_with_details?Date=${date}&Statuses=${statuses}`, 'go'),
    getDetailsByProductCustomer: (date: string): Promise<IProductCustomerItem[]> => requests.get(`order/details_by_products_customers?Date=${date}`, 'go'),
    updateProductCustomer: (data: OrderDetail[]): Promise<IProductCustomerItem[]> => requests.put(`order/details`, 'go', data),
    getOrdersGo: (date: string, warehouseID: number) => requests.get(`order/orders?${date}&WarehouseID=${warehouseID}`, 'go'),
    getOrderWithDetailsByOrderID: (orderID: number): Promise<IOrderWithDetailsItemGO> => requests.get(`order/likut/${orderID}`, 'go'),
    updateSizeInOrders: (data: IUpdateSizeInOrdersData): Promise<ISellerTableProductItem> => requests.put(`order/details/size`, 'go', data),
    getOrderStatusHistory: (orderID: number | string): Promise<OrderStatusHistoryResponse> => requests.get(`order/status/${orderID}`, 'go'),
    logOrderStatusHistory: (orderID: number, user: any, statusAzmana: number) => {
        const details = statusConverter(statusAzmana);
        return requests.patch(`api/order-status`, 'mongo', {
            orderID,
            user,
            data: {
                date: new Date(),
                StatusCode: statusAzmana,
                StatusDesc: details.status,
            },
        });
    },
    getQuotationTitlesByDateRange: (dateString: string): Promise<IQuotationTitle[]> => requests.get(`order/quotations?${dateString}`, 'go'),
    getQuotationDetailsByTitleID: (titleID: number): Promise<IOrderQuotationDetailsResponse> => requests.get(`order/quotations/details/${titleID}`, 'go'),
    changeStatusQuotation: (titleID: number, status: number) => requests.put(`order/quotations/${titleID}/status`, 'go', {status: status}),
    createQuotation: (data: IOrderQuotationPostData): Promise<IOrderQuotationDetailsResponse> => requests.post(`order/quotations`, 'go', data),
    editQuotation: (data: IQuotationDetails) => requests.put(`order/quotations/details`, 'go', data),
    getQotationProductListByCustomerID: (customerID: number, date: string): Promise<IQuotationProductListResponse> => requests.get(`order/quotations/products?CustomerID=${customerID}&Date=${date}`, 'go'),
    deleteQuotation: (titleID: number) => requests.delete(`order/quotations/${titleID}`, 'go'),
}
